import AmazonEmberCondensedBold from '../assets/fonts/AmazonEmberCdRC_Bd.ttf';
import AmazonEmberCondensedLight from '../assets/fonts/AmazonEmberCdRC_LtIt.ttf';
import AmazonEmberCondensedRegular from '../assets/fonts/AmazonEmberCdRC_RgIt.ttf';
import AmazonEmberDisplayBold from '../assets/fonts/AmazonEmberDisplay_Bd.ttf';
import AmazonEmberDisplayLight from '../assets/fonts/AmazonEmberDisplay_Lt.ttf';
import AmazonEmberDisplayRegular from '../assets/fonts/AmazonEmberDisplay_Rg.ttf';
import AmazonEmberBold from '../assets/fonts/AmazonEmber_Bd.ttf';
import AmazonEmberLight from '../assets/fonts/AmazonEmber_Lt.ttf';
import AmazonEmberRegular from '../assets/fonts/AmazonEmber_Rg.ttf';
import DigitPasswordCircle from '../assets/fonts/DigitPasswordCircle.ttf';
import DigitPasswordSquare from '../assets/fonts/DigitPasswordSquare.ttf';
export const FONTS_RELOADED_COBRANDED_GLOBAL_STYLES = `
  @font-face {
    font-family: 'Amazon Ember';
    font-weight: 700;
    src: url(${AmazonEmberBold}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember';
    font-weight: 400;
    src: url(${AmazonEmberRegular}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember';
    font-weight: 300;
    src: url(${AmazonEmberLight}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember Condensed';
    font-weight: 700;
    src: url(${AmazonEmberCondensedBold}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember Condensed';
    font-weight: 400;
    src: url(${AmazonEmberCondensedRegular}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember Condensed';
    font-weight: 300;
    src: url(${AmazonEmberCondensedLight}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember Display';
    font-weight: 700;
    src: url(${AmazonEmberDisplayBold}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember Display';
    font-weight: 400;
    src: url(${AmazonEmberDisplayRegular}) format('truetype');
  }

  @font-face {
    font-family: 'Amazon Ember Display';
    font-weight: 300;
    src: url(${AmazonEmberDisplayLight}) format('truetype');
  }

  @font-face {
    font-family: 'DigitPasswordCircle';
    font-weight: 400;
    src: url(${DigitPasswordCircle}) format('truetype');
  }

  @font-face {
    font-family: 'DigitPasswordSquare';
    font-weight: 400;
    src: url(${DigitPasswordSquare}) format('truetype');
  }
`;
//# sourceMappingURL=fonts.js.map